/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffMemoryVoiceSignedurlRequest
 */
export interface PostLiffMemoryVoiceSignedurlRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurlRequest
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurlRequest
     */
    fileExtension: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryVoiceSignedurlRequest
     */
    contentType: string;
}

/**
 * Check if a given object implements the PostLiffMemoryVoiceSignedurlRequest interface.
 */
export function instanceOfPostLiffMemoryVoiceSignedurlRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "fileExtension" in value;
    isInstance = isInstance && "contentType" in value;

    return isInstance;
}

export function PostLiffMemoryVoiceSignedurlRequestFromJSON(json: any): PostLiffMemoryVoiceSignedurlRequest {
    return PostLiffMemoryVoiceSignedurlRequestFromJSONTyped(json, false);
}

export function PostLiffMemoryVoiceSignedurlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffMemoryVoiceSignedurlRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'fileExtension': json['fileExtension'],
        'contentType': json['contentType'],
    };
}

export function PostLiffMemoryVoiceSignedurlRequestToJSON(value?: PostLiffMemoryVoiceSignedurlRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'fileExtension': value.fileExtension,
        'contentType': value.contentType,
    };
}

